import { extendServiceContainer } from '@iotize/tap';
import { JvmService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    jvm: JvmService;
  }
}

export const _TAP_SERVICE_EXTENSION_JVM_ = extendServiceContainer(
  'jvm',
  JvmService,
);
